import type { fabric } from 'fabric';

type AnnotationAssetType =
  | 'video'
  | 'audio'
  | 'raster_image'
  | 'camera_raw_image'
  | 'vector_image'
  | 'document'
  | 'presentation'
  | 'spreadsheet'
  | undefined;

// Pins are 22px across at scale 1: 40px on screen, whatever the zoom. Avatars
// are 80px pictures, one picture pixel per screen pixel at 2×.
const PIN_SCREEN_SCALE = 40 / 22;
// Stroke width on screen, whatever the zoom
const STROKE_SCREEN_WIDTH = 3;
// Video and audio strokes are sized in coordinates instead: they scale with
// the player, about 3px wide on a 1125px wide one
const PLAYER_STROKE_WIDTH = 0.8;

// Sizes follow the zoom the canvas applies (see annotationCoordinates), which
// differs from the viewer's zoom factor for documents and players
function getCanvasZoom(canvas: fabric.Canvas) {
  return canvas.getZoom() || 1;
}

export function fitObjectSize(
  canvas: fabric.Canvas,
  assetType: AnnotationAssetType
) {
  if (assetType === 'video' || assetType === 'audio') {
    return PLAYER_STROKE_WIDTH;
  }
  return STROKE_SCREEN_WIDTH / getCanvasZoom(canvas);
}

export function fitPinSize(canvas: fabric.Canvas) {
  return PIN_SCREEN_SCALE / getCanvasZoom(canvas);
}
